<template>
  <v-container>
    <BaseList
      flat
      color="primary"
      :title="$t('transfer_request_actives_operations_withdrawal')"
      :section="$route.meta.section"
      :headers="columns"
      :items="items"
      :totalRows="items.length"
      :breadcrumbs="false"
      :elevation="0"
      :height="'100%'"
      :buttons="{
        search: true,
        add: (isAccountCode && canCreate) || isExecutive
      }"
      :search="search"
      @add="handleNew"
      @search="handleSearch"
    >
      <template #header.TransferType>
        <span> {{$t('transfer_title_transfer_type')}} </span>
      </template>
      <template #header.BeneficiaryName>
        <span> {{$t('transfer_title_transfer_beneficiary')}} </span>
      </template>
      <template #header.FinancialInstitution>
        <span> {{$t('transfer_title_transfer_financial_institution')}} </span>
      </template>
      <template #header.AccountNumber>
        <span> {{$t('transfer_title_transfer_financial_account_number')}} </span>
      </template>
      <template #item.transferType="{ item }">
        {{ getSecurityTransferType(item.transferType) }}
      </template>
      <template #item.createdAt="{ item }">
        {{ item.createdAt | date('YYYY-MM-DD') }}
      </template>
    </BaseList>
  </v-container>
</template>

<script>
import BaseList from '@/components/commons/BaseList'
import { mapState } from 'vuex'
import { hasPermission } from '@/utils'
import { getSecurityTransferTypeByValue } from '@/utils/securityTransfer'

export default {
  components: { BaseList },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'transfer_title_transfer_type', value: 'transferType' },
        { text: 'beneficiary', value: 'beneficiaryName' },
        {
          text: 'transfer_title_transfer_financial_institution',
          value: 'financialInstitution'
        },
        {
          text: 'transfer_title_transfer_financial_account_number',
          value: 'accountNumber'
        },
        { text: 'portal_date', value: 'createdAt' },
        {
          text: 'Status',
          value: 'status',
          width: '100px'
        }
      ]
    }
  },
  computed: {
    ...mapState('account', ['account', 'authorityAccounts']),
    ...mapState('auth', ['user']),
    columns() {
      return this.headers.map(item => ({
        ...item,
        text: this.$t(item.text)
      }))
    },
    isExecutive() {
      return (
        (this.user?.authorityLevelsCode === 1 ||
          this.user?.authorityLevelsCode === 2 ||
          this.user?.authorityLevelsCode === 4) &&
        !this.isAccountCode
      )
    },
    isAccountCode() {
      return (
        this.user?.avobjects?.findIndex(
          item =>
            item.code === this.account.code && item.typeCode === 'accountCode'
        ) > -1
      )
    },
    canCreate() {
      return hasPermission(this.user, 'create-title-transfer')
    }
  },
  methods: {
    handleSearch(search) {
      this.search = search
    },
    handleNew() {
      this.$router.push({ name: 'SecurityTransferCreate' })
    },
    hasPermission(permission) {
      return hasPermission(this.user, permission)
    },
    getSecurityTransferType(type) {
      return this.$t(getSecurityTransferTypeByValue(type))
    }
  }
}
</script>

<style scoped>
.v-link-dialog {
  text-align: left;
  font: normal normal bold 14px/17px Lato;
  letter-spacing: 0px;
  color: #00559e;
  opacity: 1;
}
.login-button {
  width: 208px;
  background: transparent linear-gradient(112deg, #00559e 0%, #0090df 100%) 0%
    0% no-repeat padding-box;
  color: white !important;
  box-shadow: 6px 10px 14px #00000029;
  border-radius: 28px;
  opacity: 1;
}

.v-title-card {
  text-align: left;
  font: normal normal bold 16px/38px Lato;
  letter-spacing: 0px;
  color: #212529;
  opacity: 1;
}
</style>
